<template>
  <nx-bform
    ref="form"
    @submit="onSubmit"
    class="e-registration-helper-register-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    <!-- <p class="text-muted">
      {{ $t("titleDesc") }}
    </p> -->

    <div
      v-if="!isCompleted"
      class="mb-2"
      style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;"
    >
      {{errorMsg}}
    </div>
    <div v-if="!isCompleted">
     

      <template>
        <RegistrationLoginNameFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.username"
        />

        <RegistrationPasswordFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.password"
        />

        <RegistrationPasswordFormGroup
          label-cols="2"
          label="Cofirm Password"
          label-align="right"
          required
          v-model="form.confirmPassword"
        />

        <RegistrationFullNameNewFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.fullname"
            required
        />

      


        <RegistrationEmailFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.email"
          message="true"
        />

        <RegistrationPostFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.post"
          required
        />

    


        <RegistrationTelephoneFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.telephone"
          required
        />

    

     

        <CaptchaFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.captcha"
          @change-token="form.captchaToken = $event.token"
          required
        />

        <hr />

        <ERegistrationPublicTermCond v-model="accepted" />
        <div
          v-if="!isCompleted"
          class="mb-2"
          style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;"
        >
          {{errorMsg}}
        </div>
        <b-form-group>
          <b-button type="submit" class="bd-button" v-t="'send'" />
          <b-button
            class="ml-2"
            @click="resetForm"
            variant="danger"
            v-t="'cancel'"
          />
        </b-form-group>
      </template>
    </div>
    <AfterRegisterCompleted v-if="isCompleted" :exist="true" @useESS="useESS" />
    <!--<div v-else style="color:red">
      <div v-if="result=='Expired'">
        {{ $t("InvitationExpired") }} 
      </div>
      <div v-else-if="result=='NotFound'">
        {{ $t("InvitationNotFound") }}
      </div>      
      <div v-else-if="result=='Registered'">
        {{ $t("Registered") }}
      </div>  
    </div>-->
  </nx-bform>
</template>

<script>
import NxFormCaptcha from "@/components/NxFormCaptcha";
import ERegistrationPublicTermCond from "../ERegistrationPublicTermCond";
import { MemberRegistrationApi,CPSRequestRegistrationApi } from "@/api";
import RegistrationPasswordFormGroup from "@/forms/registration/RegistrationPasswordFormGroup";
import RegistrationHaveEshAcFormGroup from "@/forms/registration/RegistrationHaveEshAcFormGroup";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationNameTitleFormGroup from "@/forms/registration/RegistrationNameTitleFormGroup";
import RegistrationFullNameNewFormGroup from "@/forms/registration/RegistrationFullNameNewFormGroup";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationPostFormGroup from "@/forms/registration/RegistrationPostFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import RegistrationContactAddressFormGroup from "@/forms/registration/RegistrationContactAddressFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import ManageCertFormGroup from '@/pages/manage-cert/components/ManageCertFormGroup.vue';
import AfterRegisterCompleted from '@/public/modules/login/components/login/AfterRegisterCompleted.vue';
import { v4 as uuidv4 } from 'uuid';
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  props: {
    invitationKey: {
      type: String,
    }
  },
  components: {
    NxFormCaptcha,
    ERegistrationPublicTermCond,
    RegistrationHaveEshAcFormGroup,
    RegistrationLoginNameFormGroup,
    RegistrationNameTitleFormGroup,
    RegistrationFullNameNewFormGroup,
    RegistrationEnglishNameFormGroup,
    RegistrationChineseNameFormGroup,
    RegistrationHKIDNumberFormGroup,
    RegistrationEmailFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationPostFormGroup,
    RegistrationLanguageFormGroup,
    CaptchaFormGroup,
    RegistrationContactAddressFormGroup,
    RegistrationPasswordFormGroup,
    RegistrationESignatureFormGroup,
    ManageCertFormGroup,
    AfterRegisterCompleted
  },
  data() {
    return {
      haveAc: true,
      form: this.getForm(),
      accepted: false,
      validCode: false,
      result: [],
      nameEngDisable:false,
      guid:uuidv4(),
      fullName:"",
      isCompleted:false,
      errors: [],
      errorMsg: "",
    };
  },
  mounted() {
    this.$watch(
      () => {
        this.errors = this.$refs.form.observer.errors['server-errors']
    })
  },
  computed: {
    disabledFullName() {
      return Boolean(this.iamsmartSession);
    },
    isRegisteredIAmSmartAccount() {
      return Boolean(this.iamsmartSession?.memberID);
    }
  },
  watch: {
    errors() {
      //$('.form-control.is-invalid:first')[0].offsetParent.scrollIntoView({behavior: 'smooth'});
      // document.getElementsByClassName('main-content')[0].scrollTop = 0;
    }
  },
  async created() {
    if(this.invitationKey === null) {
      this.invitationKey = this.$route.query.key;
    }
  },
  methods: {
    getForm() {
      return {
        username: "",
        password: "",
        confirmPassword: "",
        nameEng: "",
        title: "Mr",
        surname: "",
        givenName: "",
        fullname:"",
        nameChinese: "",
        address: "",
        email: "",
        telephone: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
        accepted: false,
        idNo: "",
        post:""
      };
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.push({
        name:"Login"});
    },
    async onSubmit() {
      this.$spinner.show();
      const {  invitationKey, form } = this;

      //validation
      if(form.password!=form.confirmPassword){
        this.$dangerToast("Registration Error","Password and Confirm Password is not the same");
        return;
      }
      try{
        await CPSRequestRegistrationApi.registerCPSMember(
          {
            invitationKey:invitationKey,
            loginName: form.username,
            fullname: form.fullname,
            email: form.email,
            phone: form.telephone,
            pwd: form.password,
            propertyValues: {
              guid: invitationKey,
              hkidNumber: form.idNo,
              chineseName: form.nameChinese,
              fullName: form.fullname.trim(),
              givenName: " ",
              title: " ",
              post: form.post
            }
          },
          form.captchaToken
        );
        this.$router.push({ name: "ERegistrationRegisterCPSSuccess" });
      }
      catch ({response}) {
        if (response&&response.data) {
          console.log("response",response.data);
          this.errorMsg = translateResponseError(this, response.data);
          this.$dangerToast("Registration Error", this.errorMsg);
        }
      }

      this.$spinner.hide();
    },
    setFullName(certs)
    {
      if(certs!=null && certs.length>0)
      {
        this.form.fullname = certs[0].issuedTo;
      }

    },

    useESS() {
      this.$router.push({ name: 'Login' });
    },

    normalizeFullname(fullname) {
      return (fullname || '').split(',').join('');
    }
  },
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Application for registration as a collaborator of Electronic Submission Hub",
    "titleDesc": "To become a registered collaborator, please complete the following application form. All fields with (*) are mandatory.",
    "helperLogin": "Login as collaborator",
    "InvitationNotFound": "Invitation code not found or has been cancelled",
    "InvitationExpired": "Invitation code expired",
    "InvitationRegistered": "Invitation Code already registered"
  },
  "zh_hk": {
    "title": "申請註冊為電子資料呈交及處理系統的協作者",
    "titleDesc": "要成為註冊助理，請填寫以下申請表格。帶（*）的所有字段均為必填項。",
    "helperLogin": "以協作者身份登錄",
    "InvitationNotFound": "邀請碼無效或已被取消",
    "InvitationExpired": "邀請碼已過期",
    "InvitationRegistered": "邀請碼已被使用"    
  },
  "zh_cn": {
    "title": "申请注册为电子资料呈交及处理系统的协作者",
    "titleDesc": "要成为注册助理，请填写以下申请表格。带（*）的所有字段均为必填项。",
    "helperLogin": "以協作者身份登录",
    "InvitationNotFound": "邀请码无效或已被取消",
    "InvitationExpired": "邀请码已过期",
    "InvitationRegistered": "邀请码已被使用"
  }
}
</i18n>
